import React from 'react';
import Icon from '../../../components/AppIcon';
import AppImage from '../../../components/AppImage';

const ConversationList = ({ conversations, activeConversation, onSelectConversation, currentUserId }) => {
  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date?.toLocaleDateString();
  };

  return (
    <div className="divide-y divide-border">
      {conversations?.map((conversation) => {
        const isActive = activeConversation?.id === conversation?.id;
        
        return (
          <button
            key={conversation?.id}
            onClick={() => onSelectConversation(conversation)}
            className={`w-full p-4 flex items-start gap-3 hover:bg-muted/50 transition-smooth text-left ${
              isActive ? 'bg-primary/10' : ''
            }`}
          >
            {/* Avatar */}
            <div className="relative flex-shrink-0">
              {conversation?.participant?.avatar_url ? (
                <AppImage
                  src={conversation?.participant?.avatar_url}
                  alt={conversation?.participant?.full_name || 'Member'}
                  className="w-12 h-12 rounded-full object-cover"
                />
              ) : (
                <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center">
                  <Icon name="User" size={24} color="var(--color-primary)" />
                </div>
              )}
              {conversation?.isOnline && (
                <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-card rounded-full" />
              )}
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <h3 className="font-semibold text-foreground truncate">
                  {conversation?.participant?.full_name || 'Unknown Member'}
                </h3>
                <span className="text-xs text-muted-foreground flex-shrink-0 ml-2">
                  {formatTime(conversation?.lastMessageTime)}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <p className="text-sm text-muted-foreground truncate">
                  {conversation?.lastMessage}
                </p>
                {conversation?.unreadCount > 0 && (
                  <span className="ml-2 flex-shrink-0 w-5 h-5 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-xs font-bold">
                    {conversation?.unreadCount}
                  </span>
                )}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default ConversationList;